import React, { useEffect, useState } from 'react';
import style from './index.module.scss';
import { useLang } from '@/i18n';

interface Props {
    targetTime: number;
}
const padTime = (time: number) => String(time).padStart(2, '0');

const Countdown: React.FC<Props> = ({ targetTime }) => {
       const { t } = useLang('powerBank.EarlyBird');

    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetTime - now;
            if (distance <= 0) {
                clearInterval(timer);
                setTimeLeft({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                });
                return;
            }
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            setTimeLeft({ days, hours, minutes, seconds });
        }, 1000);
        return () => clearInterval(timer);
    }, [targetTime]);
    return (
        <div className={style.comp}>
            <div className="countdown-item">
                <div className="countdown-number">{padTime(timeLeft.days)}</div>
                <div className="countdown-text">{t('d')}</div>
            </div>
            <div className="countdown-item">
                <div className="countdown-number">{padTime(timeLeft.hours)}</div>
                <div className="countdown-text">{t('h')}</div>
            </div>
            <div className="countdown-item">
                <div className="countdown-number">{padTime(timeLeft.minutes)}</div>
                <div className="countdown-text">{t('m')}</div>
            </div>
            <div className="countdown-item">
                <div className="countdown-number">{padTime(timeLeft.seconds)}</div>
                <div className="countdown-text">{t('s')}</div>
            </div>
        </div>
    );
};
export default Countdown;
